<template>
    <div class="p-5">
        <Paginator :pagination="listaSottoprogettiProgetto.paginate"></Paginator>
        <table class="w-full">
            <thead>
            <tr>
                <th></th>
                <th></th>
                <th></th>
            </tr>
            </thead>

            <tbody>
            <template v-for="s in listaSottoprogettiProgetto.rows">
                <tr>
                    <td colspan="3" class="border border-next-gray-md-dark p-2 font-bold">Data storico: {{ $filters.toDate(s.data) }}</td>
                </tr>
                <tr class="pb-3">
                    <td class="border border-next-gray-md-dark align-top">
                        <p class="font-bold p-2">Utente della modifica</p>
                        <p class="pl-2">{{ s.created_by?.name || '---' }}</p>
                    </td>
                    <td class="border border-next-gray-md-dark align-top">
                        <p class="font-bold p-2">Responsabile</p>
                        <ul class="list-disc pl-5">
                            <li>{{ s.responsabile?.name || 'vuoto' }}</li>
                        </ul>
                    </td>
                    <td class="border border-next-gray-md-dark align-top">
                        <p class="font-bold p-2">Presentazione</p>
                        <ul class="list-disc pl-5">
                            <li v-for="r in s.presentazioni">{{ r.name }}</li>
                        </ul>
                    </td>
                    <td class="border border-next-gray-md-dark align-top">
                        <p class="font-bold p-2">Account</p>
                        <ul class="list-disc pl-5">
                            <li v-for="r in s.accounts">{{ r.name }}</li>
                        </ul>
                    </td>
                </tr>
            </template>
            </tbody>
        </table>
        <InfiniteLoading @infinite="listaSottoprogettiProgetto.fetchNextPage"
                         :identifier="listaSottoprogettiProgetto.infiniteIdentifier"
                         style="min-height: 1px">
            <template #complete>
                <div class="text-center pb-3">Non ci sono altre righe di storico.</div>
            </template>
        </InfiniteLoading>
  </div>
</template>

<script lang="ts">
import {Options, Vue, setup} from 'vue-class-component';
import {mapGetters} from 'vuex';
import clientiManager from "../api/Clienti";
import TableTooltip from "@/components/TableTooltip.vue";
import Paginator from "@/components/Paginator.vue";
import Lista from "@/setup/ListaCerca";
import InfiniteLoading from "v3-infinite-loading";

@Options({
    name: 'StoricoCliente',
    components: {InfiniteLoading, Paginator, TableTooltip},
    props: {
        id: String,
    },
    computed: {
        ...mapGetters([
            'me',
        ])
    }
})

export default class StoricoCliente extends Vue {
    id!: string
    storico: any[] = []
    listaSottoprogettiProgetto: any = setup(() => Lista(clientiManager, [], clientiManager.storico))


    created() {
        this.listaSottoprogettiProgetto.callBinds = [this.id]
        this.listaSottoprogettiProgetto.fetchData()
        // clientiManager.storico(this.id).then((response) => {
        //     this.storico = response.data
        // })
    }
}
</script>


<style lang="scss">

</style>
